import { Label } from '@/components/ui';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

type TProps = {
  description?: string;
  imageUrl: string;
  title: string;
  link: string;
}

const ToolsPageItem = ({ title, description, imageUrl, link }: TProps) => (
  <Link
    to={link}
    target='_blank'
    className={cn(
      'flex flex-row items-center rounded-lg border px-4 py-3 space-x-2 md:space-x-4',
      'hover:bg-accent hover:text-accent-foreground'
    )}>
    <img
      src={imageUrl}
      alt={'title'}
      className={'w-4 md:w-10 rounded-xl mb-auto mt-1 md:mb-0 md:mt-0'} />
    <div className='space-y-0.5'>
      <Label>
        {title}
      </Label>
      {
        description &&
        <p className='text-[0.8rem] text-muted-foreground'>
          {description}
        </p>
      }
    </div>
  </Link>
);

export default ToolsPageItem;
